/**
 * Pending Members Types
 * Pre-registered family members waiting to sign up
 */

export interface PendingMember {
  id: string;
  email: string;
  full_name: string;
  nickname: string | null;
  date_of_birth: string | null;
  phone: string | null;
  team_id: string | null;
  is_captain: boolean;
  weekend_id: string | null;
  invited_by: string | null;
  created_at: string;
  claimed_at: string | null;
  claimed_by: string | null;
}

export interface PendingMemberWithRelations extends PendingMember {
  team?: {
    id: string;
    name: string;
    color: string;
  } | null;
  weekend?: {
    id: string;
    name: string;
  } | null;
  invited_by_profile?: {
    id: string;
    full_name: string | null;
    nickname: string | null;
  } | null;
  claimed_by_profile?: {
    id: string;
    full_name: string | null;
    nickname: string | null;
    email: string | null;
  } | null;
}

export interface CreatePendingMemberData {
  email: string;
  full_name: string;
  nickname?: string;
  date_of_birth?: string;
  phone?: string;
  team_id?: string;
  is_captain?: boolean;
  weekend_id?: string;
}

export interface UpdatePendingMemberData {
  email?: string;
  full_name?: string;
  nickname?: string | null;
  date_of_birth?: string | null;
  phone?: string | null;
  team_id?: string | null;
  is_captain?: boolean;
}

